import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputTagImage from "./MultiInputTagImage";

const NestedInputImage = ({ item }) => {
  const { label, name, type, multiple, required } = item;

  const [quantityCount, setCount] = useState(item.multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "text",
        name: "",
        defaultValue: [],
      },
    ]);
  };
  return (
    <div className="col-span-1 lg:col-span-2 flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className=" w-full ">
        {quantityCount.map((item, index) => (
          <MultiInputTagImage
            key={index}
            label={label}
            length={index + 1}
            name={name}
            defaultImage={item.defaultValue[0]}
            defaultValue={item.defaultValue[1]}
            type={type}
            required={required}
          />
        ))}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default NestedInputImage;
